if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]') ? this.form.querySelector('[name=id]').disabled = false : null;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      // Skip processing if Rebuy is handling form submissions
      // Rebuy cart intercepts form submissions and handles them, so we shouldn't duplicate the process
      // Check at submit time since Rebuy loads asynchronously
      if (typeof Rebuy !== 'undefined' && Rebuy && Rebuy.Cart) {
        // Don't prevent default - let Rebuy handle it completely
        return;
      }
      
      evt.preventDefault();
      
      // Skip processing if submit was triggered by a direct-to-checkout link
      // The link's href will handle adding items via URL, preventing duplicate cart additions
      const submitButton = evt.submitter || this.querySelector('[type="submit"]');
      const clickedElement = document.activeElement;
      
      // Check if the submit was triggered by a direct-to-checkout link
      if ((submitButton && submitButton.classList.contains('js-direct-to-checkout-button')) ||
          (clickedElement && clickedElement.classList.contains('js-direct-to-checkout-button'))) {
        return;
      }
      
      if (submitButton && submitButton.classList.contains('loading')) return;
      
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      if(formData.get('properties[Pre-order]')){
        formData.append(`items[0][properties][Pre-order]`, formData.get('properties[Pre-order]'));
      }

      const landerItemProperty = localStorage.getItem('omd:landerItemProperty');
      if (landerItemProperty) {
        if (this.form.querySelector('[name=id]')) {
          formData.append('properties[lander_discount]', landerItemProperty);
        } else {
          this.form.querySelectorAll('[name$="[id]"]:not([disabled]').forEach((item, index) => {
            formData.append(`items[${index}][properties][lander_discount]`, landerItemProperty);
          })
        }
      }

      if(formData.get('properties[tn_enabled]')){
          formData.append(`items[0][properties][tn_enabled]`, 'true');
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          // this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}